<script>
    import { Line, mixins } from 'vue-chartjs' // We specify what type of chart we want from vue-chartjs and the mixins module
    const { reactiveProp } = mixins
    import 'chartjs-plugin-streaming'

    export default {
        extends: Line,
        mixins: [reactiveProp],
        data() {
            return {
                options: { //Chart.js options
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                display: true
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            type: 'realtime',
                            realtime: {         // per-axis options
                                duration: 400000,    // data in the past 20000 ms will be displayed
                                refresh: 1000,      // onRefresh callback will be called every 1000 ms
                                delay: 3000,        // delay of 1000 ms, so upcoming values are known before plotting a line
                            }
                        }]
                    },
                    legend: {
                        display: true
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    elements: { point: { radius: 0 } },
                    animation: { duration: 0 /* general animation time */ },
                    hover: { animationDuration: 0 /* duration of animations when hovering an item */ },
                    responsiveAnimationDuration: 0, /* animation duration after a resize */
                    plugins: { streaming: { frameRate: 5 /* chart is drawn 5 times every second */ } }
                }
            }
        },
                mounted() {
                // this.chartData is created in the mixin
                this.renderChart(this.chartData, this.options)
            },

        }

</script>
